import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AppComponent } from './app.component';
import { HomeComponent } from './components/home/home.component';
import { AboutComponent } from './components/about/about.component';
import { XtenderComponent } from './components/xtender/xtender.component';



const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: '/contracts' },
  { path: 'home', component: HomeComponent },
  { path: 'about', component: AboutComponent },
  { path: 'contracts', component: XtenderComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})
export class AppRoutingModule { }

export const routingComponents = [AppComponent, HomeComponent, AboutComponent];
